import {createApp} from 'vue'
import GalleryCard from './GalleryCard'

const el = '.kb-component--gallery-card'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((GalleryCardDOM)=>{
            const props = {
                result: JSON.parse(GalleryCardDOM.dataset.result) ?? {}
            }
            const component = createApp(GalleryCard, props).use(Store)
            component.mount(GalleryCardDOM)
        })
    }
}